import {
  SidePanelDS,
  TextCapitalized,
  Spacer,
  triggerToast,
  InputDS,
} from "@qivia/ui";
import { useMemo, useEffect, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { VehiclesListType } from "../vehiclesAPI";
import {
  selectVehicleDepartmentUpdatedStatus,
  updateVehicleDepartmentAsync,
  vehiclesSlice,
} from "../vehiclesSlice";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import {
  departmentsSlice,
  getDepartmentsByCompanyAsync,
  selectDepartments,
  selectGetDepartmentsByCompanyStatus,
} from "../../departments/departmentsSlice";
import { selectCompany } from "../../homeSlice";

export const DepartmentSection = (props: {
  department: string | null;
  vehicleUuid: string;
  vehiclesList: VehiclesListType[];
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const departmentsList = useAppSelector(selectDepartments);
  const getDepartmentsByCompanyStatus = useAppSelector(
    selectGetDepartmentsByCompanyStatus,
  );

  const vehicleDepartmentUpdatedStatus = useAppSelector(
    selectVehicleDepartmentUpdatedStatus,
  );

  const currentDepartmentName = useMemo(
    () =>
      (props.department &&
        departmentsList.find((d) => d.uuid === props.department)?.name) ??
      "",
    [props.department, departmentsList],
  );
  const [departmentName, setDepartmentName] = useState<string>(
    currentDepartmentName,
  );
  const onClick = useCallback(() => {
    if (!company) {
      return;
    }
    void dispatch(
      updateVehicleDepartmentAsync({
        vehicleUuid: props.vehicleUuid,
        departmentName: departmentName.trim(),
        companyUuid: company.uuid,
      }),
    );
  }, [departmentName, dispatch, company, props.vehicleUuid]);

  // const currentDepartment = useMemo(() => {
  //   return departmentsList.find((department) => department.uuid === props.department);
  // }, [departmentsList, props.department]);

  // const departmentOptions = useMemo(() => {
  //   return departmentsList.map((department) => ({
  //     value: department.uuid,
  //     label: department.name,
  //   }));
  // }, [departmentsList]);

  // const updateVehicleDepartment = useCallback(( selectedDepartment: string | null ) => {
  //   if (!company || !selectedDepartment || !selectedDepartment) return;

  //   void dispatch(updateVehicleDepartmentAsync({
  //     vehicleUuid: props.vehicleUuid,
  //     departmentName: departmentOptions.find((department) => department.value === selectedDepartment)?.label ?? null,
  //     companyUuid: company.uuid,
  //   }));
  // }, [company, departmentOptions, dispatch, props.vehicleUuid]);

  // const departmentValueOption = useMemo(() => {
  //   return departmentOptions.find((department) => department.value === currentDepartment?.uuid) ?? null;
  // }, [currentDepartment?.uuid, departmentOptions]);

  useEffect(() => {
    if (company && getDepartmentsByCompanyStatus === "idle") {
      void dispatch(getDepartmentsByCompanyAsync(company.uuid));
    }
  }, [company, dispatch, getDepartmentsByCompanyStatus]);

  useEffect(() => {
    if (vehicleDepartmentUpdatedStatus === "success") {
      void dispatch(departmentsSlice.actions.resetDepartmentsListStatus());
      void dispatch(vehiclesSlice.actions.resetVehicleUpdatedDepartmentStatus());
      triggerToast(t("vehicles.updatedDepartment.success") || "", "valid");
    } else if (vehicleDepartmentUpdatedStatus === "failed") {
      triggerToast(t("vehicles.updatedDepartment.failure") || "", "error");
      dispatch(vehiclesSlice.actions.resetVehicleUpdatedDepartmentStatus());
    }
  }, [vehicleDepartmentUpdatedStatus, t, company, dispatch]);

  if (!company) {
    return;
  }

  return (
    <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
      <SectionTitle>
        <TextCapitalized>
          {t("vehicles.sidepanel.department.title")}
        </TextCapitalized>
      </SectionTitle>
      <Spacer y={1} />
      <StyledFlex>
      <InputDS
          placeholder={t("vehicles.sidepanel.department.placeholder")}
          value={departmentName}
          onChange={(e) => setDepartmentName(e.target.value.toUpperCase())}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick();
              (e.target as HTMLInputElement).blur();
            }
          }}
          withoutSpacerBottom
          onBlur={() => onClick()}
      />
      {/* <SelectDS
          label={""}
          placeholder={t("departments.addVehicleModal.placeholder") || ""}
          value={departmentValueOption}
          options={departmentOptions}
          onChange={(selectedOption) => updateVehicleDepartment(selectedOption?.value ?? null)}
          emptyErrorMessage={t("departments.addVehicleModal.emptyErrorMessage") || ""}
          withoutSpacerBottom
          allWidth
      /> */}
      </StyledFlex>
    </SidePanelDS.Section>
  );
};

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const StyledFlex = styled.div`
  display: flex;
`;
